import DescriptiveToolTip from './DescriptiveToolTip'

export default DescriptiveToolTip



// WEBPACK FOOTER //
// ./src/legacy/components/DescriptiveToolTip/index.js